import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "SharePpoint Developer",
          "Power Platform Consulting",
          "Office 365 Solution Architect",
          "MERN Stack Developer",
          "Software Developer",
          
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 1,
      }}
    />
  );
}

export default Type;
